import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconArrowLeftOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M16.117 3.96a1 1 0 0 1 0 1.414L6.491 15h21.586a1 1 0 1 1 0 2H6.49l9.626 9.626a1 1 0 1 1-1.414 1.414L3.37 16.707a1 1 0 0 1 0-1.414L14.703 3.96a1 1 0 0 1 1.414 0" clipRule="evenodd" /></svg>;
export default SvgIconArrowLeftOutlined;